import { defineMessages } from 'utils/intl';

export default defineMessages({
  goTo: 'Przejdź do koszyka',
  emptyCart: 'Wygląda na to, że koszyk jest pusty',
  emptyCartInfo: 'Możesz to zmienić :-) Wszystko w Twoich rękach',
});
